export default "__VITE_ASSET__SwsDJmSU__"